// src/components/world/LocationVisualizer.jsx
// locationInfo → 3D-примитив. Итерация 4.2.

import React from 'react';
import { Planet, Station, Ship, Spaceport, Unknown } from './Primitives';

export default function LocationVisualizer({ locationInfo }) {
  if (!locationInfo) {
    // Пока данных нет — показываем серый «неизвестный» куб
    return <Unknown position={[0, 0, 0]} name="Локация неизвестна" />;
  }

  const type = (locationInfo.type || '').toLowerCase();
  const name = locationInfo.name || 'Локация';
  const temp = locationInfo.environment?.temperature;

  // Позиция локации — в центре сцены
  const position = [0, 0, 0];

  switch (type) {
    case 'planet':
      return <Planet position={position} temperature={temp} name={name} />;
    case 'station':
      return <Station position={position} name={name} />;
    case 'ship':
      return <Ship position={position} name={name} />;
    case 'spaceport':
      return <Spaceport position={position} name={name} />;
    default:
      return <Unknown position={position} name={name} />;
  }
}
